export const list = [
  {
    name: "Home",
    nameEn: "Home",
    path: "/",
  },
  {
    name: "O nas",
    nameEn: "About",
    path: "/about",
  },
  // {
  //   name: "Usługi",
  //   nameEn: "Services",
  //   path: "/uslugi",
  // },
  {
    name: "Oferta",
    nameEn: "Ofer",
    path: "/produkty",
  },
  // {
  //   name: "Grupa",
  //   nameEn: "Group",
  //   path: "/grupa",
  // },
  {
    name: "Kariera",
    nameEn: "Career",
    path: "/kariera",
  },
  {
    name: "Kontakt",
    nameEn: "Contact",
    path: "/kontakt",
  },
]
